import HttpClient from "./httpClient";

export interface ConfigAuditChange {
  field: string;
  before: unknown;
  after: unknown;
  /** The value was a secret: only the fact that it changed is kept. */
  redacted?: boolean;
}

export interface ConfigAuditEntry {
  id: number;
  created_at: string;
  actor_email: string;
  actor_role: string;
  action: string;
  entity_type: string;
  entity_id: string | null;
  entity_name: string | null;
  customer_id: number | null;
  customer_name: string | null;
  summary: string;
  changes: ConfigAuditChange[];
  /** `snapshot` = DB before/after diff; `request` = only the submitted fields were available. */
  change_source: "snapshot" | "request";
  http_method: string;
  route: string;
  theo_client: string | null;
}

export interface ConfigAuditPage {
  rows: ConfigAuditEntry[];
  total: number;
  page: number;
  limit: number;
}

export interface ConfigAuditFacets {
  entity_types: string[];
  actors: Array<{ email: string; role: string }>;
  customers: Array<{ id: number; name: string | null }>;
}

export interface ConfigAuditFilters {
  entityType?: string;
  actorEmail?: string;
  customerId?: string;
  search?: string;
  from?: string;
  page?: number;
  limit?: number;
}

class ConfigAuditApi extends HttpClient {
  public list = async (filters: ConfigAuditFilters): Promise<ConfigAuditPage> =>
    this.get("/api/config-audit", undefined, {
      entity_type: filters.entityType || undefined,
      actor_email: filters.actorEmail || undefined,
      customer_id: filters.customerId || undefined,
      search: filters.search || undefined,
      from: filters.from || undefined,
      page: filters.page,
      limit: filters.limit,
    });

  public facets = async (): Promise<ConfigAuditFacets> => this.get("/api/config-audit/facets");
}

const configAuditApi = new ConfigAuditApi();
export default configAuditApi;
